/* tslint:disable */
import { TimeBasedLabel } from './time-based-label';
import { TimeBasedResult } from './time-based-result';
import { TimeBasedCurve } from './time-based-curve';

/**
 */
export class ViewTimeBased {
    label?: TimeBasedLabel;
    result?: TimeBasedResult;
    curve?: TimeBasedCurve;
    imageTimebased?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-time-based.ts